import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { handleSubmit as formSubmitter } from "../../../libs/form-submitter";
import Cookies from "js-cookie";

import "../styles/contactForm.scss";
import "../styles/spinner.scss";



function NewsletterSignupFormName({
  submitCampaignID,
  submitType,
  customBg,
  onClose,
  form,
}) {
  /* Set State for TY Message */
  const [formSuccess, setFormSuccess] = useState(false);

  /* Get GAUID */
  const clientId = typeof document !== "undefined" ? Cookies.get("_ga") : null;
  const gaUID =
    clientId != null || clientId != undefined
      ? clientId.substring(6)
      : "No GAUID Detected";

  /* Get Referral Value */
    function cleanURL(url) {
      return url.split(/[?#]/)[0]; 
    }
  
    let referrer = typeof document !== "undefined" ? document.referrer.toLowerCase() : null;
    referrer = (!referrer) || (referrer === null) ? "Direct" : cleanURL(referrer);
    let muReferrer = Cookies.get("_muReferrer");
    let referrerCookie;
    referrerCookie =
      muReferrer === undefined
        ? (Cookies.set("_muReferrer", referrer, { expires: 7 }),
          (referrerCookie = Cookies.get("_muReferrer")))
        : muReferrer === "Direct" && referrer !== "Direct"
          ? (Cookies.set("_muReferrer", referrer, { expires: 7 }),
            (referrerCookie = Cookies.get("_muReferrer")))
          : muReferrer !== "Direct" && referrer !== "Direct"
            ? (Cookies.set("_muReferrer", referrer, { expires: 7 }),
              (referrerCookie = Cookies.get("_muReferrer")))
            : (referrerCookie = muReferrer);
         
  /* Get URL Params */
  const urlRef = typeof window !== "undefined" ? window.location.search : "";
  const url = urlRef.slice(1);
  const urlParams = new URLSearchParams(url);
  const utm_source = urlParams.has("utm_source")
    ? urlParams.get("utm_source")
    : "NoSource";
  const utm_medium = urlParams.has("utm_medium")
    ? urlParams.get("utm_medium")
    : "NoMedium";
  const utm_campaign = urlParams.has("utm_campaign")
    ? urlParams.get("utm_campaign")
    : "NoCampaign";
  const utm_term = urlParams.has("utm_term")
    ? urlParams.get("utm_term")
    : "NoTerm";
  const utm_content = urlParams.has("utm_content")
    ? urlParams.get("utm_content")
    : "NoContent";
  const utm_gclid = urlParams.has("gclid") ? urlParams.get("gclid") : "NoGCLID";

  /* Get Initial Cookie Value */
  let muSource = Cookies.get("_muSource");
  let muMedium = Cookies.get("_muMedium");
  let muCampaign = Cookies.get("_muCampaign");
  let muTerm = Cookies.get("_muTerm");
  let muContent = Cookies.get("_muContent");

  /* Set Cookie Value and Store for Logic App Values */
  let source;
  let medium;
  let campaign;
  let term;
  let content;
  source =
    muSource === undefined
      ? (Cookies.set("_muSource", utm_source, { expires: 7 }),
        (source = Cookies.get("_muSource")))
      : muSource === "NoSource" && utm_source !== "NoSource"
        ? (Cookies.set("_muSource", utm_source, { expires: 7 }),
          (source = Cookies.get("_muSource")))
        : muSource !== "NoSource" && utm_source !== "NoSource"
          ? (Cookies.set("_muSource", utm_source, { expires: 7 }),
            (source = Cookies.get("_muSource")))
          : (source = muSource);
  medium =
    muMedium === undefined
      ? (Cookies.set("_muMedium", utm_medium, { expires: 7 }),
        (medium = Cookies.get("_muMedium")))
      : muMedium === "NoMedium" && utm_medium !== "NoMedium"
        ? (Cookies.set("_muMedium", utm_medium, { expires: 7 }),
          (medium = Cookies.get("_muMedium")))
        : muMedium !== "NoMedium" && utm_medium !== "NoMedium"
          ? (Cookies.set("_muMedium", utm_medium, { expires: 7 }),
            (medium = Cookies.get("_muMedium")))
          : (medium = muMedium);
  campaign =
    muCampaign === undefined
      ? (Cookies.set("_muCampaign", utm_campaign, { expires: 7 }),
        (campaign = Cookies.get("_muCampaign")))
      : muCampaign === "NoCampaign" && utm_campaign !== "NoCampaign"
        ? (Cookies.set("_muCampaign", utm_campaign, { expires: 7 }),
          (campaign = Cookies.get("_muCampaign")))
        : muCampaign !== "NoCampaign" && utm_campaign !== "NoCampaign"
          ? (Cookies.set("_muCampaign", utm_campaign, { expires: 7 }),
            (campaign = Cookies.get("_muCampaign")))
          : (campaign = muCampaign);
  term =
    muTerm === undefined
      ? (Cookies.set("_muTerm", utm_term, { expires: 7 }),
        (term = Cookies.get("_muTerm")))
      : muTerm === "NoTerm" && utm_term !== "NoTerm"
        ? (Cookies.set("_muTerm", utm_term, { expires: 7 }),
          (term = Cookies.get("_muTerm")))
        : muTerm !== "NoTerm" && utm_term !== "NoTerm"
          ? (Cookies.set("_muTerm", utm_term, { expires: 7 }),
            (term = Cookies.get("_muTerm")))
          : (term = muTerm);
  content =
    muContent === undefined
      ? (Cookies.set("_muContent", utm_content, { expires: 7 }),
        (content = Cookies.get("_muContent")))
      : muContent === "NoContent" && utm_content !== "NoContent"
        ? (Cookies.set("_muContent", utm_content, { expires: 7 }),
          (content = Cookies.get("_muContent")))
        : muContent !== "NoContent" && utm_content !== "NoContent"
          ? (Cookies.set("_muContent", utm_content, { expires: 7 }),
            (content = Cookies.get("_muContent")))
          : (content = muContent);

const formik = 
  useFormik({
    initialValues: {
      submitFirstName: "",
      submitLastName: "",
      submitEmail: "",
      submitCampaignID,
      submitType,
      submitHowHear: "Other",
      submitUTMSource: source,
      submitUTMMedium: medium,
      submitUTMCampaign: campaign,
      submitUTMTerm: term,
      submitUTMContent: content,
      submitReferrer: referrerCookie,
      submitGCLID: utm_gclid,
      submitUUID: gaUID,
      submitForm: "Newsletter",
      submitAB: form,
    },

    validationSchema: Yup.object({
      submitFirstName: Yup.string(),
      submitLastName: Yup.string(),
      submitEmail: Yup.string()
        .email("Invalid email address")
        .required("Required"),
      submitHowHear: Yup.string(),
    }),

    onSubmit: () => {
      formSubmitter(formValues, submitConfig);
      setFormSuccess(true);
      setTimeout(onClose, 7000);
    },
  });

  const submitConfig = {
    preferThankYou: false,
  };

  const formValues = formik.values;

  const [isActive, setActive] = useState("false");
  const ToggleClass = () => {
    setActive(!isActive);
  };

  

  return (
    <div>
      {formSuccess ? (
        <>
          <div id="newsletterForm">
            <div className="contact-form">
              <p className="mb-1">
                Thank you for signing up for our Newsletter!
              </p>
              <p className="mb-2">
                <small>
                  This window will close automatically, or you can click the
                  button below
                </small>
              </p>
              <Button variant="primary" onClick={onClose}>
                Close
              </Button>
            </div>
          </div>
        </>
      ) : (
          <>
          <div id="newsletterForm" className={customBg}>
          <Container fluid="lg">
            <Form onSubmit={formik.handleSubmit} id="form">
              <Row className="align-items-center contact-form newsletter text-center my-3">
                <Col xs={12} className="px-0 mb-3">
                  <Row className="mb-3">
                    <Form.Group as={Col} className="email">
                      <Form.Control
                        id="submitFirstName"
                        name="submitFirstName"
                        type="text"
                        placeholder="First Name*"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.submitFirstName}
                        className={
                          formik.touched.submitFirstName &&
                          formik.errors.submitFirstName
                            ? `error`
                            : null
                        }
                      />
                      {formik.touched.submitFirstName &&
                      formik.errors.submitFirstName ? (
                        <div className="error-text">
                          {formik.errors.submitFirstName}
                        </div>
                      ) : null}
                    </Form.Group>
                    <Form.Group as={Col} className="email">
                      <Form.Control
                        id="submitLastName"
                        name="submitLastName"
                        type="text"
                        placeholder="Last Name*"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.submitLastName}
                        className={
                          formik.touched.submitLastName &&
                          formik.errors.submitLastName
                            ? `error`
                            : null
                        }
                      />
                      {formik.touched.submitLastName &&
                      formik.errors.submitLastName ? (
                        <div className="error-text">
                          {formik.errors.submitLastName}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Row>
                  <Form.Group controlId="emailGroup" className="form-row">
                    <Form.Group className="email form-col">
                      <Form.Control
                        id="submitEmail"
                        name="submitEmail"
                        type="email"
                        placeholder="Email Address *"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.submitEmail}
                        className={
                          formik.touched.submitEmail && formik.errors.submitEmail
                            ? `error`
                            : null
                        }
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        id="submtHowHear"
                        name="submitHowHear"
                        type="hidden"
                        value="Other"
                      />
                    </Form.Group>
                  </Form.Group>
                </Col>
                <Col xs={12} className="px-0">
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={ToggleClass}
                    disabled={!(formik.isValid && formik.dirty)}
                  >
                    Submit
                  </Button>
                </Col>
                <Col className="text-start">
                {formik.touched.submitFirstName && formik.errors.submitFirstName ? (
                    <div className="error-text">
                      {formik.errors.submitFirstName}
                    </div>
                  ) : null}
                  {formik.touched.submitLastName && formik.errors.submitLastName ? (
                    <div className="error-text">
                      {formik.errors.submitLastName}
                    </div>
                  ) : null}
                  {formik.touched.submitEmail && formik.errors.submitEmail ? (
                    <div className="error-text">
                      {formik.errors.submitEmail}
                    </div>
                  ) : null}
                </Col>
              </Row>
            </Form>
          </Container>
        </div>
        </>
        )
      }
    </div>
  );
}

export default NewsletterSignupFormName;
